import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminLinkConversionsQuery.ts
var r = (r, i) => t({
	queryKey: e.linkConversions(r, i),
	fetchPage: (e) => n.linkConversions(r, i, { page: e }),
	key: "conversions",
	enabled: !!r && !!i
});
//#endregion
export { r as useAdminLinkConversionsQuery };
